export default {
  namespaced: true,

  state: {
    institutes: {},
    paths: {},
    papers: {},
    achs_base: {},
    achs_spec: {},
    grades: {},
    isOpen: false,
    reg_start: null,
    reg_stop: null,
    reg_publish: null,
  },

  mutations: {
    init(state, value) {
      state.institutes = value.institutes;
      state.paths = value.paths;
      state.papers = value.papers;
      state.achs_base = value.achs_base;
      state.achs_spec = value.achs_spec;
      state.grades = value.grades;
      state.isOpen = value.isOpen;
      state.reg_start = value.reg_start;
      state.reg_stop = value.reg_stop;
      state.reg_publish = value.reg_publish;
    },
  },
};
